export default store => {
  return {
    getFirstArtist(target) {
      try {
        return target.artists[0].id;
      } catch (error) {
        store.dispatch("page/addError", error);
        return null;
      }
    },
    async getTracksByArtist(params) {
      return await store.dispatch(`artists/tracks`, {
        params
      });
    },
    async getAlbumsByArtist(params) {
      return await store.dispatch(`artists/albums`, {
        params
      });
    },
    async getArtist(params) {
      return await store.dispatch(`artists/fetch`, {
        type: "artist",
        params
      });
    },
    async getPopularArtists(params) {
      return await store.dispatch("artists/fetch", {
        type: "popular",
        params
      });
    },
    async getLatestArtists(params) {
      return await store.dispatch("artists/fetch", {
        type: "latest",
        params
      });
    },
    async getFavoriteArtists(params) {
      return await store.dispatch("artists/fetch", {
        type: "favorite",
        params
      });
    }
  };
};
